const PREFIX = '[Montaigne overlay]'

function readEnabledFromDom() {
  if (typeof document === 'undefined') {
    return false
  }
  const el = document.documentElement
  if (el && el.getAttribute('data-overlay-debug') === '1') {
    return true
  }
  try {
    if (new URLSearchParams(window.location.search).get('overlay_debug') === '1') {
      return true
    }
  } catch (e) {
    /* ignore */
  }
  try {
    if (window.sessionStorage.getItem('montaigne_overlay_debug') === '1') {
      return true
    }
  } catch (e) {
    /* ignore */
  }
  try {
    if (window.localStorage.getItem('montaigne_overlay_debug') === '1') {
      return true
    }
  } catch (e) {
    /* ignore */
  }
  return false
}

export function overlayDebugIsEnabled() {
  return readEnabledFromDom()
}

export function overlayDebugLog(...args) {
  if (!overlayDebugIsEnabled()) {
    return
  }
  console.log(PREFIX, ...args)
}

export function overlayDebugWarn(...args) {
  if (!overlayDebugIsEnabled()) {
    return
  }
  console.warn(PREFIX, ...args)
}

export function overlayDebugError(...args) {
  if (!overlayDebugIsEnabled()) {
    return
  }
  console.error(PREFIX, ...args)
}

export function overlayDebugGroup(label, fn) {
  if (!overlayDebugIsEnabled() || typeof fn !== 'function') {
    return
  }
  console.groupCollapsed(PREFIX, label)
  try {
    fn()
  } finally {
    console.groupEnd()
  }
}

/**
 * À appeler une fois au chargement du bundle (script.js).
 * Console : montaigneOverlayDebug.enable() puis recharger, ou enableSession() sans rechargement.
 */
export function overlayDebugExpose() {
  if (typeof window === 'undefined') {
    return
  }
  window.montaigneOverlayDebug = {
    isEnabled: overlayDebugIsEnabled,
    enable() {
      try {
        window.localStorage.setItem('montaigne_overlay_debug', '1')
      } catch (e) {
        /* ignore */
      }
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-overlay-debug', '1')
      }
      console.info(PREFIX, 'Debug activé (persistant). Rechargez si les logs n’apparaissent pas avant le 1er fetch.')
    },
    enableSession() {
      try {
        window.sessionStorage.setItem('montaigne_overlay_debug', '1')
      } catch (e) {
        /* ignore */
      }
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('data-overlay-debug', '1')
      }
      console.info(PREFIX, 'Debug activé pour cet onglet seulement.')
    },
    disable() {
      try {
        window.localStorage.removeItem('montaigne_overlay_debug')
        window.sessionStorage.removeItem('montaigne_overlay_debug')
      } catch (e) {
        /* ignore */
      }
      if (typeof document !== 'undefined') {
        document.documentElement.removeAttribute('data-overlay-debug')
      }
      console.info(PREFIX, 'Debug désactivé.')
    },
  }
}
